export default __webpack_public_path__ + "static/media/axa-health-solid-stacked.f365329e.svg";